import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/context/AuthContext";

export const AuthGuard = () => {
  const { isAuthenticated, isLoading, userData } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (userData?.emailPending && location.pathname !== "/activate") {
    return <Navigate to="/activate" replace />;
  }
  if (!userData?.emailPending && location.pathname === "/activate") {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};
